import PortfolioManagementComponent from "@/views/components/CopyTrade/Master/PortfolioManagementComponent/PortfolioManagementComponent";

export default function PortfolioManagement(props: { callBackFunc?: void }) {
    return (
        <PortfolioManagementComponent />
    );
}